import { useMemo } from 'react';
import PromotionCampaignList from './PromotionCampaignList/PromotionCampaignList';
import PromotionCampaignDetail from './PromotionCampaignDetail/PromotionCampaignDetail';
import { Routes, Route, Outlet, useParams, useOutlet, useLocation, useOutletContext } from 'react-router-dom-v5-compat';
import { useCampaignById, useCampaigns } from './_hooks/useCampaigns';
import qs from 'query-string';
import { useQueryStringUpdater } from './_hooks/useQueryStringUpdater';
import { withFeatureGuard } from '../Shared/RouteGuards/FeatureRoute';
import { PromotionCampaignFilters } from './PromotionCampaignList/Filters/PromotionCampaignFilters';
import { withCompanyRouteGuard } from '../Shared/RouteGuards/CompanyRouteGuard';

function CampaignListWrapper() {
  const outlet = useOutlet();
  const location = useLocation();

  const updateFilters = useQueryStringUpdater(150);

  const query = qs.parse(location.search);
  const status = query.status || undefined;
  const search = query.search || undefined;

  const currentFilters = useMemo(() => ({ 
    status: Array.isArray(status) ? status : status ? [status] : ['DRAFT','ENABLED'],
    search }
  ), [status, search]);

  const { data: campaigns, isLoading } = useCampaigns(currentFilters);

  const outletContext= useMemo(() => ({ campaigns,currentFilters }), [campaigns,currentFilters]);

  
  return (
    <>
     <PromotionCampaignFilters  search={currentFilters.search} isLoading={isLoading} onFilterChange={updateFilters} status={currentFilters.status} />
      <div style={{ display: 'flex', alignItems: 'stretch', height: '100%' }}>
        <div style={{ flex: 2 }}>
          <PromotionCampaignList
                campaigns={campaigns}
                isLoading={isLoading}
                currentFilters={currentFilters}
                onFilter={updateFilters}
                compact={outlet}
              />
        </div>
        {outlet && <div style={{ flex: 6, minWidth: 0, overflow: 'hidden', position: 'relative' }}>
              <Outlet context={outletContext}/>
        </div>}
      </div>
    </>
  );
}

function CampaignDetailWrapper() {
  const { campaignId } = useParams();
  const { campaigns } = useOutletContext() || {};
  const {data:campaign,isLoading} = useCampaignById(campaignId, campaigns);
  return (
    <PromotionCampaignDetail campaign={campaign} isLoading={isLoading} />
  );
}


const PromotionCampaignRoutes = () => (
  <Routes>
    <Route path="" element={<CampaignListWrapper /> }>
      <Route path=":campaignId" element={<CampaignDetailWrapper />}>
      </Route>
    </Route>
  </Routes>
);


export const ProtectedPromotionCampaignRoutes = 
  withCompanyRouteGuard(
    withFeatureGuard(
      PromotionCampaignRoutes,
      'promotion_campaigns'
  )
);
export default ProtectedPromotionCampaignRoutes;